module.exports = __webpack_public_path__ + "img/gimont-city-square.ab01ed55.png";